export enum ORDER_LABEL_TYPE_ICON_NAME {
  problemWithOrder = 'ProblemWithOrder',
  problemWithDocuments = 'ProblemWithDocuments',
  productType = 'ProductType',
  workWithClient = 'WorkWithClient',
}
